var React = require('react');

function BarChart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 20.0005V14.0005C5 13.4482 5.44772 13.0005 6 13.0005C6.55228 13.0005 7 13.4482 7 14.0005V20.0005C7 20.5528 6.55228 21.0005 6 21.0005C5.44772 21.0005 5 20.5528 5 20.0005Z","key":0}),React.createElement("path",{"d":"M17 20V10C17 9.44772 17.4477 9 18 9C18.5523 9 19 9.44772 19 10V20C19 20.5523 18.5523 21 18 21C17.4477 21 17 20.5523 17 20Z","key":1}),React.createElement("path",{"d":"M11 20V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20Z","key":2})]);
}

BarChart.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = BarChart;

BarChart.default = BarChart;
